export * from './DealConfigsContextType';
